import { Municipio, MunicipioSearchResponse, MunicipioFiltro } from '../../model/municipio/municipio';

/**
 * Puerto: MunicipioRepository
 * 
 * Define el contrato para acceso a datos de municipios.
 * La implementación concreta está en infrastructure/adapters/municipio/
 * 
 * Arquitectura Hexagonal:
 * - Presentation → inyecta este PUERTO (abstract class)
 * - Infrastructure → implementa este puerto (HttpMunicipioRepository)
 * 
 * @author Emerson Rodriguez - Ingeneo
 */
export abstract class MunicipioRepository {
  
  /**
   * Busca municipios con filtros y paginación por cursor (keyset pagination,
   * ver skill acceso-datos-oracle §7).
   *
   * @param filtro Filtros de búsqueda
   * @param cursor Cursor de la página (null = primera página)
   * @param size Tamaño de página
   * @param direction NEXT | PREVIOUS | LAST
   */
  abstract search(
    filtro: MunicipioFiltro,
    cursor: string | null,
    size: number,
    direction: 'NEXT' | 'PREVIOUS' | 'LAST'
  ): Promise<MunicipioSearchResponse>;
  
  /**
   * Obtiene un municipio por código DANE
   */
  abstract getByCodigo(codigo: string): Promise<Municipio>;
  
  /**
   * Obtiene municipios de un departamento
   */
  abstract getByDepartamento(cddepartamento: string): Promise<Municipio[]>;
}
